import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import classNames from 'classnames';
import styles from '../styles.module.css';

export const DEFAULT_TOOLBAR_COLUMN_WIDTH = 40;

const ToolbarMenu = ({
  columns = 4,
  columnWidth = DEFAULT_TOOLBAR_COLUMN_WIDTH,
  inheritWidth = false,
  children,
  allowScroll,
  scrollEnabled,
}: {
  columns?: number;
  columnWidth?: number;
  inheritWidth?: boolean;
  children?: React.ReactNode;
  allowScroll?: boolean;
  scrollEnabled?: boolean;
}) => {
  return (
    <div
      data-drag-abort
      // see ToolButton which sets the height of this element via this special classname
      className={`${styles.toolbarMenu} ${
        allowScroll ? 'tippy-scrollable-element' : ''
      }`}
      style={
        allowScroll && scrollEnabled
          ? {
              overflowY: 'auto',
              overflowX: 'hidden',
              maxHeight: '70vh',
            }
          : {}
      }
    >
      <div
        className={classNames(styles.toolbarMenuContent)}
        style={{ width: inheritWidth ? 'inherit' : columns * columnWidth }}
      >
        {children}
      </div>
    </div>
  );
};

export default ApplicationView(ToolbarMenu);
